import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { pub } from "@/lib/api";

let cache = null;
export function useSiteConfig() {
  const [cfg, setCfg] = useState(cache);
  useEffect(() => {
    if (cache) return;
    pub.get("/site-config").then((r) => { cache = r.data; setCfg(r.data); }).catch(() => {});
  }, []);
  return cfg;
}

export function Footer() {
  const cfg = useSiteConfig();
  return (
    <footer data-testid="site-footer" className="relative z-10 px-5 pb-[max(1rem,env(safe-area-inset-bottom))] pt-8 text-[10px] tracking-wider text-[color:var(--w1-muted)]">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 opacity-70">
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[color:var(--w1-blue)] transition-colors">PRIVACY</Link>
        <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[color:var(--w1-blue)] transition-colors">TERMS</Link>
        {cfg?.billing_contact && <span data-testid="footer-billing-contact">{cfg.billing_contact}</span>}
      </div>
    </footer>
  );
}

export function Shell({ children, testid, className = "" }) {
  return (
    <div data-testid={testid} className={`w1 w1-fx flex flex-col ${className}`}>
      <main className="relative z-10 flex-1 flex flex-col">{children}</main>
      <Footer />
    </div>
  );
}
